// extracted by mini-css-extract-plugin
module.exports = {"notice":"NotifyBanner_notice__duaha"};